import { useEffect } from 'react';
import { Dropdown, useFormContext, ZoneDateTimeInput, ZonedApiDateFormat } from 'framework/form';
import GeneralInterviewerEmployeeInput from '../../input/GeneralInterviewerEmployeeInput';
import { ValidationSchema } from 'validation-schema-library/build/validation/utils';
import { EmployeeInput } from 'domain/shared/employee';
import { SubmitButton } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

interface InterviewScheduledFormProps {
  handleCancelClick: () => void;
  isGeneral?: boolean;
  validationSchema: ValidationSchema;
}

const InterviewScheduledForm = ({
  handleCancelClick,
  validationSchema,
  isGeneral = false,
}: InterviewScheduledFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact, setValidationSchemaAction } = useFormContext();

  useEffect(() => {
    if (setValidationSchemaAction) {
      setValidationSchemaAction(validationSchema);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ZoneDateTimeInput
        label="Interview Date & Time"
        source="interviewDateTime"
        isRequired
        apiDateFormat={ZonedApiDateFormat.ISO_8601_DATETIME_WITH_OFFSET}
      />
      {isGeneral ? (
        <GeneralInterviewerEmployeeInput label="Interviewer" source="interviewerAlias" isRequired />
      ) : (
        <EmployeeInput label="Interviewer" source="interviewerAlias" isRequired />
      )}
      <Dropdown
        label="Interview Method"
        source="interviewMethod"
        options={[
          { value: 'online', label: 'Online' },
          { value: 'offline', label: 'Offline' },
        ]}
        isRequired
      />

      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default InterviewScheduledForm;
